var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS6Card2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.458,
    cy: 19.6075,
    r: 18,
    transform: "rotate(2.24144 19.458 19.6075)",
    fill: "#F95790"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.9136 26.4351L14.9941 24.3767L19.9629 19.6474C21.0726 18.57 21.642 17.6582 21.6712 16.9121C21.6926 16.3659 21.5366 15.9194 21.2032 15.5728C20.8832 15.2267 20.4567 15.0432 19.9238 15.0223C18.8712 14.9811 18.0705 15.4969 17.5214 16.5695L15.2564 15.1198C15.7336 14.1778 16.3951 13.4698 17.241 12.9958C18.0868 12.5219 19.0027 12.3042 19.9886 12.3428C21.2543 12.3923 22.3245 12.8345 23.1992 13.6694C24.0744 14.4909 24.4857 15.5745 24.433 16.9201C24.3762 18.3723 23.5517 19.8345 21.9595 21.3067L19.1145 23.9375L24.3705 24.1432L24.2664 26.8012L14.9136 26.4351Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS6Card2);
export default __webpack_public_path__ + "static/media/s6-card2.59712f49de50d7f9ad0da31144815f7c.svg";
export { ForwardRef as ReactComponent };